import React from 'react';
import IbanLogo from './icons/iban.svg';

const Logo = ({ ...props }) => (<IbanLogo {...props} />);

export default Logo;
